import script from "./tenant-details-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./tenant-details-page.vue?vue&type=script&setup=true&lang=ts"

import "./tenant-details-page.vue?vue&type=style&index=0&id=26e2c2bf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e2c2bf"]])

export default __exports__